export const CURRENCY = "gbp";
